import React from 'react';

import { DEFAULT_PAGE_SIZE } from '../constants';

// Adding in here? remember to add to ./prop-types/index.js
export const globals = {
  api: '/api/whatson/search/',
  isExperienceEditor: document.body.classList.contains('ExperienceEdit'),
  labels: {
    advancedLabel: 'N/A',
    buttonLabel: 'N/A',
    categoriesLabel: 'N/A',
    dateFromPlaceholder: 'N/A',
    datesInfo: 'N/A',
    datesLabel: 'N/A',
    dateToPlaceholder: 'N/A',
    event: 'Event',
    keywordsInfo: 'N/A',
    keywordsLabel: 'N/A',
    keywordsPlaceholder: 'N/A',
    locationInfo: 'N/A',
    locationLabel: 'N/A',
    locationPlaceholder: 'N/A',
    mobileAccordionCloseLabel: 'Close Search',
    mobileAccordionOpenLabel: 'Search again?',
    meet: 'Club Meet',
    name: 'N/A',
    noResultsLabel: 'N/A',
    placeOfInterest: 'Place Of Interest',
    radiusInfo: 'N/A',
    radiusLabel: 'N/A',
    radiusPlaceholder: 'Please select',
    resetButtonLabel: 'Reset',
    resultCtaButtonLabel: 'N/A',
    resultsSummary: 'Showing #{0} results near you',
    showAllLabel: 'N/A',
    showEventsLabel: 'N/A',
    temporaryHolidaySite: 'Temporary Holiday Site',
    title: 'Find events & places of interest',
    typesLabel: 'N/A',
    staleSearchTitle: 'Update your search, before performing another search',
    staleResetTitle: 'Search is already reset',
  },
  radiusOptions: [],
  categories: [],
  googleApiKey: '',
  types: [],
  pageSize: DEFAULT_PAGE_SIZE,
  defaultImageUrls: [
    '/-/media/images/unsplash/lahtnsplash.jpg',
    '/dist/images/Default-ResultCard-Image.svg',
  ],
  parentItemId: null,
};

export const GlobalsContext = React.createContext({
  globals,
});
